var _style, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaseNestPurpleNegativeRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700.3 331.5",
    style: {
      enableBackground: "new 0 0 700.3 331.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#7A5CF0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,123.4c16.2,0,29.1,7.6,36.8,20.3L69.8,154c-6.2-8.9-14-13.3-23.5-13.3c-15.6,0-27.4,12.4-27.4,28.2 c0,16,11.7,28.4,27.4,28.4c9.2,0,17.1-4.4,23.5-13.2L83,194.3c-7.8,12.6-21,20.2-36.8,20.2C20.4,214.5,0,194.3,0,168.9 C-0.5,143.8,21.2,123,46.2,123.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.5,212.6h-17.4v-9.8c-6.4,7.6-16,11.7-27.9,11.7c-18.3,0-30.4-10.1-30.4-25.2s12.4-24.9,32.2-24.9h24.7 v-5.7c0-12.1-6.8-18.7-18.7-18.7c-9.8,0-16.9,4.3-24.2,13l-10.8-11c8.7-12.6,21.7-18.7,36.8-18.7c21.5,0,35.7,13,35.7,36.4V212.6z  M150.7,177.9h-22.4c-10,0-15.5,3.6-15.5,10.7c0,7.3,6.2,11.5,15.3,11.5c12.6,0,22.6-8.7,22.6-20.6V177.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.5,185.9c7.6,8,15.3,12.4,24.5,12.4c8,0,14-3.4,14-9.8c0-5.2-3.7-7.3-12.3-10.8l-8.9-3.7 c-15.5-6.4-22.7-13.2-22.7-25.4c0-15.6,13-25.2,30.7-25.2c12.6,0,22.6,4.4,30.2,13.5L236,148.5c-5.3-5.6-12.7-8.8-20.4-8.9 c-7.3,0-11.9,2.8-11.9,8.3c0,4.4,3,6.8,11.5,10.3l8.4,3.4c16.5,6.9,23.8,14,23.8,26.3c0,8.3-3,14.9-9.2,19.7 c-6.2,4.6-13.9,6.9-23.1,6.9c-13.7,0.2-26.7-6.1-35.2-16.9L190.5,185.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.9,175.1c2.3,14.2,13.5,22.9,28.4,22.9c9.1,0,17.6-3.4,25.4-10.3l8.9,12.8c-10,9.4-21.5,14-34.8,14 c-26.6,0-46.9-19.7-46.9-45.5c-0.5-25.1,20.4-46.2,45.1-45.7c23.1,0,40.3,17.2,40.3,40c-0.1,3.9-0.5,7.9-1.4,11.7L274.9,175.1z  M322.7,160.5c-0.2-13.3-10.1-21.3-22.4-21.3s-22.2,8.3-25,21.3H322.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 534.6,
    cy: 165.7,
    r: 165.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M545.8,179.6h-47.3c1.7,10.3,9.8,16.7,20.7,16.7c6.6,0,12.8-2.5,18.5-7.5l6.5,9.3c-6.7,6.6-15.9,10.3-25.3,10.2 c-19.4,0-34.1-14.3-34.1-33.1c-0.4-18.2,14.9-33.6,32.8-33.2c16.8,0,29.3,12.5,29.3,29.1C546.7,173.9,546.4,176.8,545.8,179.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M516.9,153.5c-8.9,0-16.2,6.1-18.2,15.5h34.5C533.1,159.3,525.9,153.5,516.9,153.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.4,120c4.8-4.8,12.5-4.8,17.3,0c4.8,4.8,4.8,12.5,0,17.3c-4.8,4.8-12.5,4.8-17.3,0c0,0,0,0,0,0 C438.6,132.5,438.6,124.8,443.4,120z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M479.7,206.8h-13.4v-33.5c0-8.5-6.4-15.4-14.2-15.4s-14.3,6.9-14.3,15.4v33.5h-13.3v-33.2 c0-16.5,12.4-29.9,27.6-29.9s27.6,13.4,27.6,29.9V206.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.1,203.2c-4.5,3.4-10.1,5-16.8,5c-10,0.1-19.4-4.4-25.6-12.3l7.8-8.5c5.6,5.8,11.1,9,17.8,9 c5.8,0,10.2-2.5,10.2-7.1c0-3.7-2.7-5.3-8.9-7.9l-6.5-2.7c-11.2-4.7-16.5-9.6-16.5-18.5c0-11.4,9.4-18.3,22.4-18.3 c9.2,0,16.4,3.2,22,9.8l-7.4,8.4c-3.9-4.1-9.3-6.4-14.9-6.4c-5.3,0-8.7,2.1-8.7,6.1c0,3.2,2.2,4.9,8.4,7.5l6.1,2.5 c12,5,17.3,10.2,17.3,19.1C598.8,194.9,596.6,199.8,592.1,203.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M647.3,206.8c-3.7,0.9-7.5,1.3-11.2,1.4c-14.6,0-23.4-7.2-23.4-22.1v-31h-10.3v-11.8h10.3v-16.6h13.7v16.7h18.9 v11.8h-18.9V185c0,8.1,4.3,11,12.5,11c1.9,0,4.7-0.3,8.4-0.6V206.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseNestPurpleNegativeRgb);
export default __webpack_public_path__ + "static/media/CaseNest_Purple_Negative_RGB.4992a4d79ebeb7f2b719350a2719ffa1.svg";
export { ForwardRef as ReactComponent };